const MONTHLY = 'monthly'
const YEARLY = 'yearly'
const ONETIME = 'one-time'

export default {
  MONTHLY,
}

export { MONTHLY, YEARLY, ONETIME }
